import classNames from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { EEntityType } from '../../types/filters';

interface IEntityTypeToggle {
  favoriteEntityType: EEntityType | null;
  setEntityType(type: EEntityType | null): void;
}

export const EntityTypeToggle: React.FC<IEntityTypeToggle> = ({ favoriteEntityType, setEntityType }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['filters']}>
        <div className={styles['row']}>
          <ul className={styles['favorites-type']}>
            <li
              onClick={() => setEntityType(null)}
              className={classNames(
                styles['favorites-type-item'],
                favoriteEntityType !== EEntityType.Newbuilding && styles['favorites-type-item--active'],
              )}
            >
              Объявления
            </li>
            <li
              onClick={() => setEntityType(EEntityType.Newbuilding)}
              className={classNames(
                styles['favorites-type-item'],
                favoriteEntityType === EEntityType.Newbuilding && styles['favorites-type-item--active'],
              )}
            >
              ЖК
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};
